module.exports = __webpack_public_path__ + "img/mark-myfolder-open.750fe1d.svg";